
export const sortVideosByPosition = (videos = []) => {
  return [...videos].sort((a, b) => a.position - b.position);
};
